export const questionTypes = {
    multipleChoice:     'multiple-choice',
    multipleAnswer:     'multiple-answer',
    lueckentext:        'lueckentext',
    freitext:           'freitext',
    nurText:           'nur_text',
    clicksvg:           'klicksvg',
    clickmatrix:        'klickmatrix',
    dndlistsort:        'dnd_list_sort',
    dndgroupsort:       'dnd_group_sort',
    dnd1u1zuordnungen:  'dnd_1u1_zuordnungen',
    ctWebertest:        'ct_weber_test',
    frankfurterAdaptiveTest: 'frankfurter_adaptive_test',
    militaryReactionTest:    'military_reaction_test',
    flexibleReactionTest:       'flexible_reaction_test',
    personalityTest:       'persönlichkeitstest',
    professionTypeTest:       'berufswahltest',
};

export default questionTypes;
